  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Puntos Recogida</li>
            <li class="breadcrumb-item">Búsqueda de solicitudes</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda de solicitudes</h2>
          <button *ngIf="canAccessCrearSolicitud()" (click)="openModalRegistrationRequest()" type="button"
            class="btn btn-primary" data-toggle="modal"><span class="icon-add"></span>Nueva
            Solicitud</button>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
    <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
    <!-- Formulario de búsqueda -->
    <form *ngIf="mostrarFiltros" class="container form-search py-3" [formGroup]="searchForm">
      <div class="row form">

        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="idSolicitud">Ref. Solicitud </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idSolicitud" id="idSolicitud" placeholder="Ref. Solicitud" type="number">
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 200px; max-width: 300px;"
          *ngIf="canViewResource('PR-PUNTORECOGIDA') || canViewResource('PR-ENV-GEST') || canViewResource('PR-ENV-CONS')">
          <label for="puntoRecogida">Punto de recogida</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="puntoRecogida" id="puntoRecogida" placeholder="Punto de recogida" multiple>
                <mat-option *ngFor="let pto of ptoArray" [value]="pto">
                  {{ pto.razonSocial }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 300px; max-width: 400px;"
          *ngIf="canViewResource('PR-GESTOR') || canViewResource('PR-ENV-GEST') || canViewResource('PR-ENV-CONS')">
          <label for="gestor">Gestor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="gestor" id="gestor" placeholder="Gestor" multiple>
                <mat-option *ngFor="let pto of gestorArray" [value]="pto">
                  {{ pto.razonSocial }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="acondicionamiento">Acondicionamiento </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="acondicionamiento" id="acondicionamiento" placeholder="Acondicionamiento">
                <mat-option *ngFor="let item of acondicionamientoArray" [value]="item.id">
                  {{ item.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('acondicionamiento')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'acondicionamiento')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>


        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple>
                <mat-option *ngFor="let des of estadosArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>


        <div style="flex: 1 1 190px; max-width: 190px;">
          <label for="fechaDesde">Fecha solicitud desde</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="fechaDesde" formControlName="fechaDesde">
              <mat-datepicker-toggle matIconSuffix [for]="fechaDesde"></mat-datepicker-toggle>
              <mat-datepicker #fechaDesde>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaDesde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 190px; max-width: 190px;">
          <label for="fechaHasta">Fecha solicitud hasta </label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepickerHasta" formControlName="fechaHasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepickerHasta"></mat-datepicker-toggle>
              <mat-datepicker #datepickerHasta>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaHasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 300px; max-width: 400px;">
          <label for="cnae">Código LER y descripción de ENVALORA </label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination class="lib-ge-select" [endPointFilter]="codigosLerEndpoint"
              [updateList]="updateList" [descripcion]="getLerDescription"
              [formControlNameSelect]="getFormControl('codigoLer')" [objQueryName]="getObjectQuery"
              [placeHolder]="'-- Código LER y descripción de ENVALORA --'" [customClass]="rightHolder('codigoLer')">
            </lib-ge-select-pagination>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 250px;" *ngIf="canViewRol('PR-GESTOR')">
          <label for="autoFactura">Prefacturada</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="autoFactura" id="autoFactura" placeholder="Prefacturada">
                <mat-option *ngFor="let item of optionArray" [value]="item">
                  {{ item.value }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('autoFactura')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'autoFactura')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('PR-ENV-GEST') ||  this.canViewResource('PR-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('PR-ENV-GEST') ||  this.canViewResource('PR-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
              <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </div>

    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
        <div class="text-right">
          <div class="d-inline">

            <div class="d-flex d-inline dropdown show">
              <button *ngIf="canAccessCrearAutoFactura()" type="button" class="btn btn-primary margin-bton-auto"
                data-toggle="modal" (click)="crearAutoFactura()"><span class="icon-add"></span>Crear
                Prefactura</button>

              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>

          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario.</p>
      </div>
    </ng-template>
  </div>
